import React, { PureComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { Dropdown } from 'components/cosmos/v2/dropdown';
import MoreOptionsButton from 'components/moreOptionsButton';
import { I18n, translate } from 'components/translate';
import PropTypes from 'prop-types';

import { CAMPAIGNS_STATUS } from '../../../constants';

import styles from './campaignListActions.module.scss';

class CampaignListActions extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    campaignStatus: PropTypes.string,
    visualizeLink: PropTypes.string,
    handleToggleStatus: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.statusActions = {
      [CAMPAIGNS_STATUS.DISABLED]: {
        id: 'enable-campaign',
        iconName: 'play',
        renderContent: this.renderEnableAction
      },
      [CAMPAIGNS_STATUS.ENABLED]: {
        id: 'disable-campaign',
        iconName: 'pause',
        renderContent: this.renderDisableAction
      }
    };

    this.visualizeAction = {
      id: 'visualize-campaign',
      iconName: 'external-link',
      onClick: this.handleVisualizeClick,
      renderContent: this.renderVisualizeAction
    };

    this.actions = [];

    this.setActions(props);
  }

  componentDidUpdate() {
    this.setActions(this.props);
  }

  get showableActions() {
    const { campaignStatus } = this.props;

    return (
      [CAMPAIGNS_STATUS.ENABLED, CAMPAIGNS_STATUS.DISABLED].indexOf(
        campaignStatus
      ) !== -1
    );
  }

  setActions = ({ campaignStatus, visualizeLink }) => {
    if (!this.showableActions) {
      return;
    }

    const { handleToggleStatus } = this.props;

    this.actions = [
      { ...this.statusActions[campaignStatus], onClick: handleToggleStatus }
    ];

    if (visualizeLink) {
      this.actions.push(this.visualizeAction);
    }
  };

  handleVisualizeClick = () => {
    const { visualizeLink } = this.props;

    visualizeLink && window.open(visualizeLink, '_blank');
  };

  renderEnableAction = () => (
    <I18n data-test="enable-action" label="campaign.enable_campaign" />
  );

  renderDisableAction = () => (
    <I18n data-test="disable-action" label="campaign.disable_campaign" />
  );

  renderVisualizeAction = () => (
    <I18n data-test="visualize-action" label="general.visualize" />
  );

  render() {
    const { t } = this.props;
    const className = classnames('campaigns_actions', this.props.className);

    return (
      <div className={className} data-test="actions-container">
        {this.showableActions && (
          <Dropdown>
            <MoreOptionsButton label={t('general.view_more')} />
            <Dropdown.Menu>
              {this.actions.map((action) => (
                <Dropdown.MenuItem
                  onClick={action.onClick}
                  key={action.id}
                  className={styles.action}
                  role="button"
                >
                  <FontAwesomeIcon
                    icon={['fal', action.iconName]}
                    className="_mr-2"
                  />
                  {action.renderContent()}
                </Dropdown.MenuItem>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    );
  }
}

export default translate()(CampaignListActions);
